<template>
  <div>
    <div class="congratulations section content is-size-5 is-family-secondary">
      <h1 class="title" v-html="congratulation" />
      <hr class="mini-hr content">
      <p class="blurb" v-html="blurb" />
    </div>
    <div class="share-social columns is-vcentered has-text-centered">
      <div class="column is-6 has-share-title">
        <span class="is-size-5 has-text-weight-bold is-uppercase">Share The News:</span>
      </div>
      <div class="column is-6 has-share-icons">
        <SocialFacebook />
        <SocialTwitter />
        <SocialLinkedIn />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      blurb(state) {
        return state[this.$route.params.slug].blurb
      },
      congratulation(state) {
        return state[this.$route.params.slug].congratulation
      },
    }),
  },
  components: {
    SocialFacebook: () => import('@/components/Social/Facebook.vue'),
    SocialTwitter: () => import('@/components/Social/Twitter.vue'),
    SocialLinkedIn: () => import('@/components/Social/LinkedIn.vue'),
  }
}
</script>
